const fields = new WeakMap();

export function registerField(element, model, name) {
  fields.set(element, { model, name });
}

export function unregisterField(element) {
  fields.delete(element);
}

export function fieldOf(element) {
  return fields.get(element);
}

// The attributes of an element are bound one after the other, so one that is listed before form-field looks
// for its field before form-field has said which it is. What it does with the field waits until all are bound.
export function afterSiblingsBound(action) {
  Promise.resolve().then(action);
}
